import Modal from "../Base/Modal";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  width: 500px;

  .headerTabs {
    display: flex;
    gap: 20px;

    .tab {
      font-weight: 700;
      font-size: 20px;
      color: #004576;
    }

    .activeTab {
      border-bottom: 3px solid #48c8f4;
    }

    .closeButtonModal {
      margin-left: 336px;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .clientName {
    font-weight: 700;
    font-size: 16px;
    color: #211c1d;
    margin-top: 24px;
  }

  .progressBar {
    display: flex;
    gap: 10px;
    margin-top: 20px;

    .progress {
      width: 25%;

      .name {
        text-align: center;
        font-size: 12px;
      }

      .bar {
        margin-top: 5px;
        width: 100%;
        height: 15px;
        border-radius: 50px;
        background-color: #dfdfdf;
      }

      .active {
        background-color: #48c8f4;
      }
    }
  }

  .infoSection {
    margin-top: 20px;

    .section {
      margin-top: 20px;
      .header {
        font-weight: 400;
        font-size: 12px;
        color: #211c1d;
      }

      .info {
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3d;
      }

      .emailLink {
        color: #008df1;
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
`;

const IncomingClientDetails = ({
  data,
  isIncomingClientDetailsModalShow,
  incomingClientDetailsModalOnClose,
}) => {
  const isThisBarACtive = (barName = 0, status = "") => {
    if (status.toString().toLowerCase() === "registered") {
      if (barName <= 1) return true;
    } else if (status.toString().toLowerCase() === "in progress") {
      if (barName <= 2) return true;
    } else if (status.toString().toLowerCase() === "ready to launch") {
      if (barName <= 3) return true;
    } else if (status.toString().toLowerCase() === "account opened") {
      if (barName <= 4) return true;
    }
  };

  const formatPhoneNumber = (str) => {
    let cleaned = ("" + str).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  const handleMailClick = (mailId) => {
    window.open(`mailto:${mailId}`);
  };

  return (
    <Modal
      show={isIncomingClientDetailsModalShow}
      onClose={incomingClientDetailsModalOnClose}
    >
      <Wrapper>
        <div className="headerTabs">
          <div className="tab">Client Details</div>
          <div
            className="closeButtonModal"
            onClick={incomingClientDetailsModalOnClose}
          >
            X
          </div>
        </div>
        <div className="clientName">{data?.clientName || ""}</div>
        <div className="progressBar">
          <div className="progress">
            <div className="name">Registered</div>
            <div
              className={`bar ${isThisBarACtive(1, data?.status) && "active"}`}
            ></div>
          </div>
          <div className="progress">
            <div className="name">In Progress</div>
            <div
              className={`bar ${isThisBarACtive(2, data?.status) && "active"}`}
            ></div>
          </div>
          <div className="progress">
            <div className="name">Ready to Launch</div>
            <div
              className={`bar ${isThisBarACtive(3, data?.status) && "active"}`}
            ></div>
          </div>
          <div className="progress">
            <div className="name">Account Opened</div>
            <div
              className={`bar ${isThisBarACtive(4, data?.status) && "active"}`}
            ></div>
          </div>
        </div>
        <div className="infoSection">
          <div className="section">
            <div className="header">Email</div>
            <div className="info emailLink" onClick={handleMailClick}>
              {data?.email || ""}
            </div>
          </div>
          <div className="section">
            <div className="header">Phone</div>
            <div className="info">{formatPhoneNumber(data?.phone) || ""}</div>
          </div>
        </div>
      </Wrapper>
    </Modal>
  );
};

export default IncomingClientDetails;
